import { Breadcrumb as AntdBreadcrumb, BreadcrumbProps } from 'antd';
import { FunctionComponent } from 'react';

export const Breadcrumb: FunctionComponent<BreadcrumbProps> = (props) => {
  return <AntdBreadcrumb className="the5ers-breadcrumb" {...props} />;
};
